/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Else, If, Then } from "react-if";
import { Tag, theme } from "@nordcloud/gnui";
import { StatusDot } from "~/components/Styled/StatusDot";

type Props = {
  tag: "source" | "dependent";
};

export function BaselineTag({ tag }: Props) {
  return (
    <If condition={tag === "source"}>
      <Then>
        <Tag
          color="success"
          text="Baseline"
          showClose={false}
          css={{
            height: "0.875rem",
            margin: "0",
            borderRadius: "2.625rem",
            padding: "0 0.375rem",
            fontSize: theme.fontSizes.xs,
            ".tag-text": {
              margin: 0,
              fontWeight: theme.fontWeights.regular,
            },
          }}
        />
      </Then>
      <Else>
        <StatusDot size="medium" color={theme.color.background.success} />
      </Else>
    </If>
  );
}
